<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { bulkUpdate } from 'src/components/DevicesSettings/ApplicationSettings/app_settings_helper';
	//Stores
	import { getDeviceSettings, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	//Design system components
	import { Alert, Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { InputClickEvent } from 'src/types/InputClickEvent';

	export let device: Device;

	const id = device.id;
	$: settingsStore = getDeviceSettings(id);
	let settings = readDeviceSettings(id);
	$: settings = $settingsStore ?? settings;

	$: inputType = settings?.[`input:${device.channel}`]?.type;
	$: isButtonType = inputType === 'button';

	let checked = $devices[id].virtual_input || false;
	let disabled = false;

	const save = async (e: InputClickEvent) => {
		if (!isButtonType) return;

		disabled = true;
		checked = e.target.checked;
		const virtual_input = checked;
		const res = await bulkUpdate(id, { virtual_input });

		if (!res?.isok) {
			// Revert to prev value when request fails
			checked = !checked;
		}

		onSettingsResponse(res, device);
		disabled = false;
	};
</script>

{#if isButtonType}
	<Toggle size="m" {checked} {disabled} class="mb-s" on:click={save} id="toggle-erabvly">
		{$format('virtual_input_label', {
			default: 'Enable virtual events for the input state',
		})}
	</Toggle>
{:else}
	<Alert
		type="warning"
		class="mb-s"
		heading={$format('virtual_input_button_type_required_heading', {
			default: 'Button input type required',
		})}
		message={$format('virtual_input_button_type_required_message', {
			default: 'Set the input type to Button to enable the virtual input remote trigger.',
		})}
		cta={{
			title: $format('virtual_input_go_to_input_settings', {
				default: 'Go to Input settings',
			}),
		}}
		on:cta_click={() => navigateToSetting(id, 'settings', 'input')}
	/>
{/if}
